import { FC, useEffect } from 'react';
import EfImg from '@elem/ui/ef-img';
import { getIsPadWidth } from '@elem/utils/devices';
import { useDP3Store } from '@elem/compPage/DP3/DP3Provider';
import css from './index.module.scss';
import { useLang } from '@/i18n';

const VS: FC = () => {
    const { t } = useLang('delta3Plus.AU3');
    const { pageStatus } = useDP3Store();

    const items = [
        {
            pc: 'https://websiteoss.ecoflow.com/upload/image/1736841338748/left-pc.jpg',
            h5: 'https://websiteoss.ecoflow.com/upload/image/1736841338487/right-h5.jpg',
            label: t('label1'),
            list: [
                { title: 'Fixed in car, single function.', desc: 'Limited to one use, restricting versatility.' },
                { title: 'Space constraints.', desc: 'Accessories take up valuable space, creating cramped living conditions.' },
                {
                    title: 'Complex installations.',
                    desc: 'Time-consuming and technically challenging, with tangled cords making the camping experience more frustrating.',
                },
                { title: 'High cost.', desc: 'Accessories quickly add up, making the setup expensive.' },
            ],
        },
        {
            pc: 'https://websiteoss.ecoflow.com/upload/image/1736841338267/right-pc.jpg',
            h5: 'https://websiteoss.ecoflow.com/upload/image/1739157352108/left.jpg',
            label: t('label2'),
            list: [
                { title: 'Portable and on-the-go power.', desc: 'Versatile for vehicles, outdoors, and at home, offering flexibility and cost-effectiveness.' },
                {
                    title: '3-in-1 Vehicle Battery Care Solution.',
                    desc: 'The 800W Alternator Charger works as a charger, maintainer, and jump starter, saving time, money, and in-car space.',
                },
                {
                    title: '800W Alternator Turbocharged.',
                    desc: 'Charge 8× faster than cigarette chargers. Recharge DELTA 3 Plus in just 1.3 hours, ensuring power when needed.',
                },
                { title: '6-Step Easy DIY Installation.', desc: 'Quickly set up for any scenario with no technical hassle.' },
                {
                    title: 'Smart App Control.',
                    desc: 'Monitor energy usage, power consumption, and charging status in real-time. Manage your vehicle’s power system and appliances from anywhere.',
                },
            ],
        },
    ];

    useEffect(() => {
        if (typeof window !== 'undefined') {
            const item2 = document.querySelector('.item-2') as HTMLDivElement;
            const line = document.querySelector('.vs-line') as HTMLDivElement;
            // resize 检测
            const callback = () => {
                if (item2 && getIsPadWidth()) {
                    line.style.top = `${item2.offsetHeight}px`;
                } else {
                    line.style.top = '0px';
                }
            };
            callback();
            window.addEventListener('resize', callback);

            return () => {
                window.removeEventListener('resize', callback);
            };
        }
    }, []);
    return (
        <div className={`${css.thecomp}`}>
            {items.map((item, idx) => (
                <div className={`vs-item item-${idx + 1}`} key={item.label}>
                    <div style={{ position: 'relative' }}>
                        <EfImg pc={item.pc} h5={item.h5} />
                        <div className={`vs-item-label label-${idx + 1}`}>{item.label}</div>
                    </div>
                    <ul className="vs-item-content">
                        {item.list.map((j, idx) => (
                            <li key={idx}>
                                <div className="title">{j.title}</div>
                                <div className="desc">{j.desc}</div>
                            </li>
                        ))}
                    </ul>
                </div>
            ))}

            {/* vs */}
            <div className="vs-line"></div>
        </div>
    );
};

export default VS;
